import { render } from "./PhotoLoad.vue?vue&type=template&id=08bf4b27"
import script from "./PhotoLoad.vue?vue&type=script&lang=js"
export * from "./PhotoLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__